import IDS_INPUT_FIELDS_TOKENS from '@ids-core/input-fields/src/variables/js/variables.module.js';
import * as React from 'react';
export default {
  IDS_INPUT_FIELDS_TOKENS,
  React
};